import { FC } from 'react'
import { useGetTranslations } from '@/root/shared-hooks'

const BENEFIT_KEYS = [
  'authBenefitViewTickets',
  'authBenefitOrderHistory',
  'authBenefitSaveData',
  'authBenefitReceipts',
  'authBenefitBusinessAccount',
] as const

export const RegistrationBenefits: FC = () => {
  const { getTranslation } = useGetTranslations()

  return (
    <div className="text-neutral-darkest text-base leading-relaxed">
      <p>{getTranslation('authRegistrationBenefitsIntro')}</p>

      <p className="mt-3 font-bold">{getTranslation('authRegistrationBenefitsTitle')}</p>

      <ul className="mt-2 list-none space-y-1">
        {BENEFIT_KEYS.map((key) => (
          <li key={key}>
            <span className="me-2">&bull;</span>
            {getTranslation(key)}
          </li>
        ))}
      </ul>
    </div>
  )
}
